<template>
  <header class="gs-asset-section-header">
    <div class="gs-asset-section-header__text">
      <span class="gs-asset-section-header__eyebrow">ASSET TYPE {{ index }} OF {{ total }}</span>
      <h1 class="gs-asset-section-header__title">{{ title }}</h1>
      <p v-if="guidance" class="gs-asset-section-header__guidance">{{ guidance }}</p>
    </div>
    <div class="gs-asset-section-header__switch">
      <span class="gs-asset-section-header__switch-label">Show this section to affiliates</span>
      <gd-toggle :value="enabled" @change="$emit('toggle', $event)" />
    </div>
  </header>
</template>

<script>
export default {
  name: 'AssetSectionHeader',
  props: {
    index: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 10,
    },
    title: {
      type: String,
      default: '',
    },
    guidance: {
      type: String,
      default: '',
    },
    enabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.gs-asset-section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 20px;
}

.gs-asset-section-header__text {
  min-width: 0;
}

.gs-asset-section-header__eyebrow {
  display: block;
  margin-bottom: 7px;
  color: var(--gs-primary);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  line-height: 1;
}

.gs-asset-section-header__title {
  margin: 0;
  color: var(--gs-foreground);
  font-size: 24px;
  font-weight: 650;
  line-height: 1.3;
}

.gs-asset-section-header__guidance {
  margin: 8px 0 0;
  max-width: 640px;
  color: var(--gs-muted-foreground);
  font-size: 14px;
  line-height: 1.55;
}

.gs-asset-section-header__switch {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
  padding-top: 4px;
}

.gs-asset-section-header__switch-label {
  color: var(--gs-muted-foreground);
  font-size: 13px;
  line-height: 1.3;
}

@media (max-width: 720px) {
  .gs-asset-section-header {
    flex-direction: column;
    gap: 14px;
  }

  .gs-asset-section-header__switch {
    padding-top: 0;
  }
}
</style>
